require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-alumni-take-python-class-project-to-new-heights.json") })
        }
      }, "path---blog-alumni-take-python-class-project-to-new-heights");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-alumni-take-python-class-project-to-new-heights!./.cache/json/blog-alumni-take-python-class-project-to-new-heights.json
// module id = 589
// module chunks = 231608221292675